import {
	ecobanq,
	ezeewallet,
	paymeroUpi,
	akontoPayUpi,
	creditCard,
	neteller,
	emailCurrencies,
	onlyCurrencies,
	mobileNumberForDenmark,
	validateCardNumberbyProvider,
	validateCardNumberbyAvailability
} from '~/components/payment/deposit/data/validate';
import { PaymentMethodT } from '~/components/payment-beta/types/deposit';
import { AccountT } from '../types/templates';

type SelectedAccountT = Record<string, string | number | unknown>;

export const creditcard = (account: AccountT, method: PaymentMethodT) => {
	const { methodName, hasMasterCardMethods, hasVisaMethods } = method;
	const { cn, id, vm, vy } = account;

	const isValidID = creditCard.cid.isAccepted(id) as boolean;
	const isValidCN = (creditCard.cn.isAccepted(cn) &&
		validateCardNumberbyProvider(methodName, cn) &&
		validateCardNumberbyAvailability(hasMasterCardMethods, hasVisaMethods, cn)) as boolean;

	const ccValidAcc = isValidCN || isValidID;
	const ccValidDate = Boolean(vm && vy && creditCard.date.isAccepted(vm, vy));

	return ccValidAcc && ccValidDate ? {} : null;
};

export const netteller = (account: SelectedAccountT) =>
	neteller.id.isAccepted(account.id) && neteller.externalid.isAccepted(account.externalid)
		? { externalid: account.externalid }
		: null;

export const email = async (account: SelectedAccountT) =>
	(await emailCurrencies.em.isAccepted(account.email)) ? { em: account.email } : null;

export const paymero = (account: SelectedAccountT) =>
	paymeroUpi.externalid.isAccepted(account.externalid) ? { externalid: account.externalid } : null;

export const akontoPay = (account: SelectedAccountT) =>
	akontoPayUpi.externalid.isAccepted(account.externalid) ? { externalid: account.externalid } : null;

export const onlyCurrency = (account: SelectedAccountT) =>
	onlyCurrencies.cu.isAccepted(account.cu) ? { cu: account.cu } : null;

export const emailCurrency = async (account: SelectedAccountT) =>
	(await emailCurrencies.em.isAccepted(account.email)) && onlyCurrencies.cu.isAccepted(account.cu)
		? { em: account.email, cu: account.cu }
		: null;

export const ezeeWallet = async (account: SelectedAccountT) =>
	(await ezeewallet.externalid.isAccepted(account.externalid)) && ezeewallet.pwd.isAccepted(account.pwd)
		? { externalid: account.externalid }
		: null;

export const ecoBanq = (account: SelectedAccountT) =>
	ecobanq.externalid.isAccepted(account.externalid) && ecobanq.pwd.isAccepted(account.pwd)
		? { externalid: account.externalid }
		: null;

export const phone = (account: SelectedAccountT) =>
	mobileNumberForDenmark.countryCode.isAccepted(account.countryCode) &&
	mobileNumberForDenmark.number.isAccepted(account.phoneNumber)
		? { countryCode: account.countryCode, phoneNumber: account.phoneNumber }
		: null;

// Here we validate the last used account data and return the spec object that will be sent while deposit execute
const accountValidator = {
	creditcard,
	netteller,
	akontoPay,
	paymero,
	email,
	ecoBanq,
	phone,
	ezeeWallet,
	onlyCurrency,
	emailCurrency
};

export default accountValidator;
